namespace Solovis.UI.Buttons {

    /**
     * options:
     * 
     * width: width of the button
     * text: text for the button
     * element: jquery element to append to the button
     * prependElement: if true, will prepend the element instead of appending it
     * html: inner html for the button.  Overrides text and element
     * click: action to take when the button is clicked
     * shiftclick: action to take when the button is shift-clicked
     * tooltipOptions: tooltip options for the button (refer to Solovis.UI.Tooltip)
     * cssRules: array of objects of type
     *   {
     *       rule,
     *       value
     *   }
     * size: "small", "large", or "default"
     */
    export class Button {

        public _width;
        public _text;
        public _element;
        public _html;
        public _prependElement;
        public _click;
        public _tooltipOptions;
        public _cssRules;
        public _size;

        public _button;

        constructor(options) {
            this._width = options.width ? options.width : null;
            this._text = options.text ? options.text : null;
            this._element = options.element ? options.element : null;
            this._html = options.html ? options.html : null;
            this._prependElement = options.prependElement ? options.prependElement : null;
            this._click = options.click ? options.click : null;
            this._tooltipOptions = options.tooltipOptions ? options.tooltipOptions : null;
            this._cssRules = options.cssRules ? options.cssRules : null;
            this._size = options.size ? options.size : null;

            if (!this._text && !this._element && !this._html) {
                console.log("Solovis.UI.Buttons.DropdownButton: No text/element/html is provided.");
            }

            this._create();
        }

        public _create() {
            var self = this;

            this._button = $("<button>")
                .addClass("btn btn-primary");

            switch (this._size) {
                case "small":
                    this._button.addClass("btn-xs");
                    break;
                case "large":
                    this._button.addClass("btn-lg");
                    break;
                default:
                    this._button.addClass("btn-solovisdefault");
                    break;
            }

            if (Solovis.isNotNull(this._width)) {
                if ($.isNumeric(this._width)) {
                    this._button.width(this._width);
                }
                else if (this._width.indexOf("%") !== -1 ||
                    this._width.indexOf("px") !== -1 ||
                    this._width.indexOf("em") !== -1) {
                    // TODO: options doesn't exist. what was intent here?
                    //this._button.css("width", options.width);
                }
            }

            if (this._text) {
                this._button.text(this._text);
            }

            if (this._element) {
                if (this._prependElement) {
                    this._element
                        .prependTo(this._button);
                }
                else {
                    this._element
                        .appendTo(this._button);
                }
            }

            if (this._html) {
                this._button.html(this._html);
            }

            this._button.click(function (e) {
                self._click(e);
            });

            if (this._tooltipOptions) {
                this._button.solovisTooltip(this._tooltipOptions);
            }

            if (this._cssRules) {
                Solovis.UI.DomHelper.applyCssRules(this._button, this._cssRules);
            }
        }


        public getElement() {
            var self = this;
            return this._button;
        }
    }

}
